import { Check, Star } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export default function Pricing() {
  const { t } = useI18n();
  const plans = t("pricing.plans");

  const scroll = (h) => {
    const el = document.querySelector(h);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="pricing" className="section bg-white" data-testid="section-pricing">
      <div className="container-x">
        <div className="max-w-3xl">
          <div className="eyebrow">{t("pricing.eyebrow")}</div>
          <h2 className="h2 mt-4">{t("pricing.title")}</h2>
          <p className="lede mt-5">{t("pricing.lede")}</p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {plans.map((p, i) => {
            const isPremium = p.highlight;
            return (
              <div
                key={i}
                className={`relative rounded-3xl p-8 flex flex-col ${
                  isPremium
                    ? "bg-brand-charcoal text-white border border-brand-gold/50 shadow-lift"
                    : "bg-white border border-brand-line hover:shadow-soft"
                } transition-transform duration-200 hover:-translate-y-1`}
                data-testid={`pricing-card-${i}`}
              >
                {isPremium && p.badge && (
                  <div className="absolute -top-3 start-6 bg-brand-gold text-brand-charcoal text-[10px] font-bold uppercase tracking-[0.18em] px-3 py-1 rounded-full flex items-center gap-1">
                    <Star className="h-3 w-3" /> {p.badge}
                  </div>
                )}
                <div className={`text-sm font-semibold uppercase tracking-[0.22em] ${isPremium ? "text-brand-gold" : "text-brand-green"}`}>
                  {p.name}
                </div>
                <div className="mt-4 flex items-baseline gap-2">
                  <div className={`text-3xl md:text-4xl font-extrabold ${isPremium ? "text-white" : "text-brand-charcoal"}`}>
                    {p.price}
                  </div>
                </div>
                <div className={`text-xs mt-1 ${isPremium ? "text-white/60" : "text-brand-charcoal/60"}`}>
                  {p.period}
                </div>
                <ul className="mt-6 space-y-2.5 flex-1">
                  {p.features.map((f, j) => (
                    <li key={j} className={`flex items-start gap-2.5 text-sm ${isPremium ? "text-white/85" : "text-brand-charcoal/80"}`}>
                      <span className={`mt-0.5 h-4.5 w-4.5 rounded-full flex items-center justify-center shrink-0 ${isPremium ? "bg-brand-gold text-brand-charcoal" : "bg-brand-greenSoft text-brand-green"}`}>
                        <Check className="h-3 w-3" />
                      </span>
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
                <button
                  onClick={() => scroll(i === 3 ? "#partners" : "#early-access")}
                  className={`mt-7 rounded-full py-3 text-sm font-semibold transition-colors duration-200 ${
                    isPremium
                      ? "bg-brand-gold text-brand-charcoal hover:bg-white"
                      : "bg-brand-charcoal text-white hover:bg-brand-ink"
                  }`}
                  data-testid={`pricing-cta-${i}`}
                >
                  {p.cta}
                </button>
              </div>
            );
          })}
        </div>

        <div className="mt-8 text-center text-xs text-brand-charcoal/60">
          {t("pricing.note")}
        </div>
      </div>
    </section>
  );
}
